import React, { useState, useEffect } from "react";
import api from "../../api/api";

function useNotesSelector(serviceId: string, formNotes: string) {
  const [showNotes, setShowNotes] = useState(false);

  const [notesAdded, setNotesAdded] = useState("");

  const handleClick = () => setShowNotes(!showNotes);

  const notesText = formNotes ? "View Private" : "Add Private";

  const addNotes = async () => {
    if (!serviceId || notesAdded === "Added") return;

    const body = {
      notes: formNotes,
      id: serviceId,
    };
    const note = await api.post("/api/addPrivateNote", body);

    if (note.data === "Added") setNotesAdded(note.data);
  };

  useEffect(() => {
    if (!notesAdded) return;

    let timeout: ReturnType<typeof setTimeout>;

    timeout = setTimeout(() => {
      setNotesAdded("");
    }, 1000);

    return () => clearTimeout(timeout);
  }, [notesAdded]);

  return {
    addNotes,
    notesText,
    handleClick,
    showNotes,
    notesAdded
  };
}

export default useNotesSelector;
